import { Route, Redirect } from "react-router-dom";

export const AdminLoginRoute = ({ component: Component, ...rest }) => {
	const adminToken = localStorage.getItem("admin-token");
	const userToken = localStorage.getItem("user-token");

	const isLoggedIn = adminToken;

	const toast = "load toast";
	return (
		<Route
			{...rest}
			render={(props) => {
				if (!userToken) {
					if (!isLoggedIn) {
						return <Component {...props} />;
					} else {
						// localStorage.setItem("toast", toast);
						return (
							<Redirect
								to={{
									pathname: "/admin-dashboard",
									state: {
										from: props.location,
									},
								}}
							/>
						);
					}
				} else {
					return (
						<Redirect
							to={{
								pathname: "/dashboard",
								state: {
									from: props.location,
								},
							}}
						/>
					);
				}
			}}
		/>
	);
};
